const printBadgeType: Record<any, string> = {
  10: 'Yeni',
  20: 'Size Özel',
  30: 'Yakında',
};

export default printBadgeType;
